import React, { useRef } from 'react';
/** lib, const **/
import classNames from 'classnames';
import { useInViewFadeUp, useInViewFadeIn } from 'lib/use-in-view';
import { SERVICE_NAME } from '../../const';
/** components **/
import { FadeUp, ParallaxItem } from 'components/organisms';
/** styles **/
import s from '../../styles/organisms/possible-Items.module.scss';
import BgLogo from 'assets/images/bg-logo.svg';

export const PossibleItems: React.FC = () => {
  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  const inViewRef2 = useRef<HTMLHeadingElement>(null);
  const inViewRef3 = useRef<HTMLHeadingElement>(null);
  const inViewRef4 = useRef<HTMLHeadingElement>(null);
  const inViewRef5 = useRef<HTMLHeadingElement>(null);
  useInViewFadeUp([inViewRef1, inViewRef3, inViewRef4, inViewRef5]);
  useInViewFadeIn([inViewRef2]);
  return (
    <FadeUp>
      <div className={s.possibleItemsWrapper}>
        <h3 className={classNames(s.beforeFadeUp, s.mainFeatureTitle)} ref={inViewRef1}>
          P-manだから叶う、安心なくらし
        </h3>
        <p className={s.conciergeText}>
          <span>まるで"ペットのコンシェルジュ"</span><br />
          <span>マンションの1階に</span>
        </p>
        <div className={s.imagesRow}>
          <img className={s.image01} src={require('assets/images/feature01.png')} alt={SERVICE_NAME} />
          <img className={classNames(s.image02)} src={require('assets/images/feature02.png')} alt={SERVICE_NAME} />
        </div>
        <div className={classNames(s.beforeFadeIn, s.inner)} ref={inViewRef2}>

          <p className={s.leadText}>
            ペットのコンシェルジュ <span>×</span> 互助コミュニティ
          </p>
          <div className={s.row}>
            <div className={classNames(s.beforeFadeUp, s.item)} ref={inViewRef3}>
              <h3>いっぱい使える!</h3>
              <p>
                ペットシッター・犬の保育園の<span>利用回数券付き＆追加利用もお得価格！</span>仕事が忙しい方も安心。保育園送迎も入居者特典でラクチン＆クイックに！
              </p>
            </div>
            <div className={classNames(s.beforeFadeUp, s.delay01, s.item)} ref={inViewRef4}>
              <h3>いつでも使える!</h3>
              <p>
                いざという時も、ちょっと⾒守って欲しい時も、<span>頼れる味⽅がいっぱい！</span>
                <br />
                ペットシッターなどの専門家はもちろん、飼い主同士のつながりがあるのも安心。
              </p>
            </div>
            <div className={classNames(s.beforeFadeUp, s.delay02, s.item)} ref={inViewRef5}>
              <h3>いつまでも使える!</h3>
              <p>
                ペットが⽼齢や病気になっても、安⼼できる<span>慣れ親しんだ環境でずっと</span>過ごせる。
                <br />
                「P-man」なら移動にも負担がかかりません。
              </p>
            </div>
          </div>
        </div>
        <ParallaxItem className={s.parallaxBg}>
          <img src={BgLogo} alt={SERVICE_NAME} />
        </ParallaxItem>
      </div>
    </FadeUp>
  );
};
